import React from 'react';
import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { ButtonPrimary } from './layout/StyledComponents';

const CardContainer = styled.div`
    background: ${theme.colors.green1};
    margin: 0 16px 72px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 24px 16px 0;
    text-align: left;
    position: relative;
    .logo {
        width: 230px;
        padding: 0;
        margin: 36px auto 0;
    }
    button {
        width: 100%;
    }
    h2 {
        text-align: center;
        font-family: Poppins;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 132.5%; /* 37.1px */
        letter-spacing: 6.16px;
        text-transform: uppercase;
        color: ${theme.colors.green3};
        margin-bottom: 32px;
    }
    .gatsby-image-wrapper {
        margin-bottom: 40px;
    }
    p {
        margin-bottom: 16px;
        span {
            font-weight: 700;
            color: ${theme.colors.green3};
        }
    }
    .second-par {
        text-align: left;
    }
    b {
        text-align: left;
    }
    @media ${theme.device.tablet} {
        .logo {
            position: absolute;
            width: 230px;
            padding: 0;
            margin: 36px auto 0;
        }
        .gatsby-image-wrapper {
            width: 85%;
            img {
                width: 100%;
            }
        }
        h2 {
            text-align: left;
        }
    }
    @media ${theme.device.tablet} {
        width: 90%;
        box-sizing: border-box;
        align-items: center;
        margin: 0 auto 120px;
        gap: 48px;
        padding: 60px 60px 40px 60px;
        .logo {
            position: absolute;
            bottom: 36px;
            right: 18px;
            margin: 0;
        }
        p:last-of-type {
            margin-bottom: 40px;
        }
        h2 {
            margin-bottom: 32px;
            font-size: 40px;
            font-weight: 700;
            letter-spacing: 1.88px;
            line-height: 132.5%; /* 53px */
        }
        button {
            width: 209px;
        }
        .gatsby-image-wrapper {
            width: 335px;
            flex-shrink: 0;
            img {
                width: 100%;
            }
        }
        p {
            max-width: 489px;
        }
        h2 {
            text-align: left;
        }
    }
    @media ${theme.device.laptop} {
        flex-direction: row;
        max-width: 1064px;
        padding: 60px 60px 40px 60px;
        align-items: start;
        .copy {
            position: relative;
            top: 16px;
        }
        .logo {
            bottom: 30px;
            right: 30px;
            width: 227px;
        }
    }
`;

export const DentalPlanCard = () => {
    return (
        <CardContainer className="container">
            <StaticImage src="../images/dental-plans.png" alt="girl giving thumbs up" />
            <div className="copy">
                <h2>First Care Dental Plan</h2>
                <p>
                    Dental savings made simple. Sign up for our dental membership plan and{' '}
                    <span>save at least 30%.</span>
                </p>
                <p className="second-par">
                    <b>Starting at: $29.95/mo *</b>
                </p>
                <a
                    href="https://firstcaredental.launchsavings.com/"
                    rel="noreferrer"
                    target="_blank"
                >
                    <ButtonPrimary fill>Sign Up Now</ButtonPrimary>
                </a>
            </div>
            <StaticImage
                className="logo"
                src="../images/common/logo.png"
                alt="first care dental logo"
                placeholder="none"
                quality={100}
            />
        </CardContainer>
    );
};
